import { Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DocumentDto } from '@bo-client/shared/models/documentDto';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentService {
  constructor(private fb: FormBuilder) {}

  createDocumentUploadForm(doc: DocumentDto) {
    return this.fb.group({
      id: [doc.id],
      cokDocId: [doc.cokDocId],
      displayName: [doc.displayName],
      fileName: [doc.fileName],
      url: [doc.url],
      tag: [doc.tag]
    });
  }
}
